import { type VeevaVaultAssetImportCounts, VeevaVaultAssetImportStatus } from '@atlas/types'
import { Chip } from '@atlas/ui-primitives'

const FILTERS: { label: string; status?: VeevaVaultAssetImportStatus }[] = [
	{ label: 'All' },
	{ label: 'In progress', status: VeevaVaultAssetImportStatus.IN_PROGRESS },
	{ label: 'Completed', status: VeevaVaultAssetImportStatus.COMPLETED },
	{ label: 'Failed', status: VeevaVaultAssetImportStatus.FAILED },
]

interface StatusFiltersProps {
	/** Across every page, so a toggle's count is what it will list. */
	counts: VeevaVaultAssetImportCounts
	/** `undefined` shows every import. */
	value: VeevaVaultAssetImportStatus | undefined
	onChange: (status: VeevaVaultAssetImportStatus | undefined) => void
}

/** Status toggles with their counts, plus a live marker while the list is still being polled. */
export function StatusFilters({ counts, value, onChange }: StatusFiltersProps) {
	const isLive = counts[VeevaVaultAssetImportStatus.IN_PROGRESS] > 0
	const total = Object.values(counts).reduce((a, b) => a + b, 0)
	return (
		<div className="flex flex-wrap items-center gap-ds-2">
			{FILTERS.map(({ label, status }) => {
				const count = status ? counts[status] : total
				const active = value === status
				return (
					<Chip
						key={label}
						as="button"
						type="button"
						size="sm"
						variant={active ? 'primary' : 'muted'}
						aria-pressed={active}
						onClick={() => onChange(status)}
					>
						{label} <span className="ml-ds-1 tabular-nums opacity-70">{count}</span>
					</Chip>
				)
			})}
			{isLive && (
				<span className="ml-auto flex items-center gap-ds-2 text-ds-xs text-ds-text-muted">
					<span className="h-2 w-2 rounded-ds-full bg-ds-success motion-safe:animate-pulse" />
					Updating live
				</span>
			)}
		</div>
	)
}
